import { setReviewReactionAction } from '../../../shared/actions/reviews';
import { EStatus } from '../../../shared/repositories/newbuilding-card/entities/reviews/LikeSchema';
import { fetchSetReviewReactionWeb } from '../../../shared/repositories/newbuilding-reviews/v1/set-review-reaction-web';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { getLabelFromState, trackNewbuildingReviewsAnalytic } from '../../../shared/utils/analytics/reviewsAnalytics';
import { getAnalyticsUser } from '../../../shared/selectors/analytics';
import {
  getBuilders,
  getNewbuildingId,
  getNewbuildingReviewsStat,
  getReviewById,
} from '../../../shared/selectors/newbuilding';
import { getProductsData } from '../../../shared/selectors/analytics/builder';
import { EType } from '../../../shared/repositories/newbuilding-reviews/entities/set_review_reaction_web/SetReviewReactionWebRequestSchema';

interface IParams {
  reviewId: string;
  type: EStatus;
}

export const setReviewReaction = ({ reviewId, type }: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { response } = await fetchSetReviewReactionWeb({
        httpApi,
        parameters: { reviewId, type: type as unknown as EType },
      });

      dispatch(setReviewReactionAction({ reviewId, type: response.type }) as any);

      const state = getState();

      const user = getAnalyticsUser(state);

      const builder = getBuilders(state)[0] || null;
      const id = getNewbuildingId(state);
      const products = [getProductsData(id, builder)];

      const review = getReviewById(reviewId)(state) || { like: { status: EStatus.Unknown } };
      const label = getLabelFromState({ state: review.like.status, payload: type });

      const reviewsStat = getNewbuildingReviewsStat(state);

      const page = {
        pageType: 'CardJK',
        siteType: 'desktop',
        extra: {
          type: 'review',
          review_id: reviewId,
          rating: reviewsStat?.rating,
        },
      };

      trackNewbuildingReviewsAnalytic({
        action: 'Click_sopr',
        category: 'NewbuildingReviews',
        label,
        user,
        page,
        products,
      });
    } catch (error) {
      logger.error(error, {
        domain: 'setReviewReaction',
        message: error.message,
      });
    }
  };
};
